module.exports = __webpack_public_path__ + "img/ico_close.e793e460.svg";